import React from 'react';

import { tv } from '@utilities';
import OverlayTooltip from '../OverlayTooltip';

export type SlugVariant = 'soft' | 'outlined';

type SlugProps = {
  text: React.ReactNode;
  tooltip?: string | null;
  color?: SlugColorType | false;
  variant?: SlugVariant;

  className?: string;
  style?: NullableCSS;
};

const slugVariants = tv({
  base: 'truncate px-sm py-xs font-medium text-tiny rounded-md text-center',
  variants: {
    variant: {
      soft: '',
      outlined: 'bg-transparent border',
    },
    color: {
      main: '',
      gray: '',
      danger: '',
      success: '',
      warning: '',
      none: '',
    },
  },
  compoundVariants: [
    { variant: 'soft', color: 'main', class: 'bg-[#6366f133] text-[#6366f1]' },
    { variant: 'soft', color: 'gray', class: 'bg-[#6b728033] text-[#9ca3af]' },
    {
      variant: 'soft',
      color: 'danger',
      class: 'bg-[#ef444433] text-[#ef4444]',
    },
    {
      variant: 'soft',
      color: 'success',
      class: 'bg-[#10b98133] text-[#10b981]',
    },
    {
      variant: 'soft',
      color: 'warning',
      class: 'bg-[#f59e0b33] text-[#f59e0b]',
    },
    {
      variant: 'outlined',
      color: 'main',
      class: 'border-[#6366f1] text-[#6366f1]',
    },
    {
      variant: 'outlined',
      color: 'gray',
      class: 'border-[#9ca3af] text-[#9ca3af]',
    },
    {
      variant: 'outlined',
      color: 'danger',
      class: 'border-[#ef4444] text-[#ef4444]',
    },
    {
      variant: 'outlined',
      color: 'success',
      class: 'border-[#10b981] text-[#10b981]',
    },
    {
      variant: 'outlined',
      color: 'warning',
      class: 'border-[#f59e0b] text-[#f59e0b]',
    },
  ],
  defaultVariants: {
    variant: 'soft',
    color: 'main',
  },
});

const Slug: React.FC<SlugProps> = ({
  text,
  color,
  style,
  tooltip,
  variant = 'soft',
  className,
}) => {
  const element = (
    <div
      style={style}
      className={slugVariants({
        variant,
        color: color === false ? 'none' : color || 'main',
        class: className,
      })}
    >
      {text}
    </div>
  );

  return tooltip ? (
    <OverlayTooltip tooltip={tooltip}>{element}</OverlayTooltip>
  ) : (
    element
  );
};

export default React.memo(Slug) as typeof Slug;
